// react
import { createContext, useContext } from 'react';

export interface CookiePreferencesContextValue {
  openCookiePreferences: () => void;
}

export const CookiePreferencesContext = createContext<
  CookiePreferencesContextValue | undefined
>(undefined);

export function useCookiePreferences() {
  const context = useContext(CookiePreferencesContext);

  if (!context) {
    throw new Error(
      'useCookiePreferences must be used within CookiePreferencesProvider',
    );
  }

  return context;
}
